import { useState, useEffect } from 'react';
import { Table, Button, Tag, message, Popconfirm, Modal } from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import API from '../api/client';

const sectorLabels = {
  gida: 'Gıda & İçecek',
  temizlik: 'Temizlik & Hijyen',
  mobilya: 'Mobilya & Ekipman',
  teknoloji: 'Teknoloji & Yazılım',
  tekstil: 'Tekstil & Üniforma',
  diger: 'Diğer',
};

const SupplierApplicationsPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  const load = async () => {
    try {
      const res = await API.get('/supplier-applications');
      setData(res.data);
    } catch { message.error('Veriler yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await API.put(`/supplier-applications/${id}/read`);
    load();
  };

  const handleDelete = async (id) => {
    await API.delete(`/supplier-applications/${id}`);
    message.success('Silindi');
    load();
  };

  const columns = [
    {
      title: 'Firma', dataIndex: 'companyName', key: 'companyName',
      render: (text, record) => (
        <span style={{ fontWeight: record.read ? 400 : 700 }}>{text}</span>
      ),
    },
    { title: 'Yetkili', dataIndex: 'contactPerson', key: 'contactPerson' },
    { title: 'Telefon', dataIndex: 'phone', key: 'phone' },
    {
      title: 'Sektör', dataIndex: 'sector', key: 'sector',
      render: (s) => <Tag color="blue">{sectorLabels[s] || s}</Tag>,
    },
    {
      title: 'Durum', dataIndex: 'read', key: 'read',
      render: (read) => read ? <Tag>Okundu</Tag> : <Tag color="red">Yeni</Tag>,
    },
    {
      title: 'Tarih', dataIndex: 'createdAt', key: 'createdAt',
      render: (d) => d ? new Date(d).toLocaleDateString('tr-TR') : '-',
    },
    {
      title: 'İşlem', key: 'action',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button size="small" icon={<EyeOutlined />} onClick={() => { setDetail(record); markRead(record._id); }}>Detay</Button>
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <h2 style={{ marginBottom: 20 }}>Tedarikçi Başvuruları</h2>
      <Table columns={columns} dataSource={data} rowKey="_id" loading={loading} scroll={{ x: 800 }} />

      <Modal
        title="Başvuru Detayı"
        open={!!detail}
        onCancel={() => setDetail(null)}
        footer={null}
        width={500}
      >
        {detail && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div><strong>Firma:</strong> {detail.companyName}</div>
            <div><strong>Yetkili:</strong> {detail.contactPerson}</div>
            <div><strong>Telefon:</strong> {detail.phone}</div>
            <div><strong>E-posta:</strong> {detail.email}</div>
            <div><strong>Sektör:</strong> {sectorLabels[detail.sector] || detail.sector}</div>
            <div><strong>Ürünler:</strong> {detail.products}</div>
            {detail.message && <div><strong>Ek Bilgi:</strong> {detail.message}</div>}
            <div><strong>Tarih:</strong> {detail.createdAt ? new Date(detail.createdAt).toLocaleString('tr-TR') : '-'}</div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default SupplierApplicationsPage;
